import { computed, defineStore, ref } from '#imports';
import type { IYandexSmartCaptcha } from '@gladesinger/vue3-yandex-smartcaptcha/dist/types';

/**
 * - Инициализирует стор в компоненте с формой
 * - Делаем watch(token, (val) => if (val.length > 0) { ...logic() } )
 * - После запроса обнуляем капчу - captchaReset()
*/

export enum CaptchaProcessEnum {
	Feedback,
	Login,
	Register,
	ForgetPassword,
}

export const useCaptchaStore = defineStore('Captcha', () => {
	const yaCaptcha = ref<IYandexSmartCaptcha | null>(null);
	const isInvalidCaptcha = computed(() => yaCaptcha.value === null);

	const captchaToken = ref<string>('');
	const captchaProcess = ref<CaptchaProcessEnum>();

	// captcha - @on-success
	const setCaptchaToken = (token: string) => captchaToken.value = token;

	const captchaExecute = (process: CaptchaProcessEnum) => {
		if (isInvalidCaptcha.value) return;

		captchaProcess.value = process;

		// Вызов капчи
		yaCaptcha.value?.execute();
	};

	const captchaReset = () => {
		if (isInvalidCaptcha.value) return;

		setCaptchaToken('');
		captchaProcess.value = undefined;
		yaCaptcha.value?.reset();
	};

	// const config = useRuntimeConfig();
	// const siteKey = computed(() => config.public.SMARTCAPTCHA_CLIENT_KEY as string ?? '');
	const siteKey = 'ysc1_NBjm11BWWV6ENjNg9xT5HIpq1mSh8qqMvhVvyruY0962f1ae';

	// https://github.com/Gladesinger/vue3-yandex-smartcaptcha?tab=readme-ov-file#%D0%BF%D1%80%D0%BE%D0%BF%D1%81%D1%8B
	const captchaProps = computed(() => ({
		siteKey,
		language: 'ru',
		invisible: true,
		hideShield: true,
	}));

	return {
		yaCaptcha,
		captchaProps,
		captchaToken,
		captchaProcess,
		setCaptchaToken,
		captchaExecute,
		captchaReset,
	};
});
